module.exports = __webpack_public_path__ + "static/media/undo.64933c3c.svg";